import getField from '@form/formGenerator'

export const mairieSaveUrl = `${import.meta.env.VITE_API_URL}/api/mairies/save`

export const mairieFormObject = {
  id: null,
  name: null,
  isActive: false
}

export const mairieFormFields = (mairieFormObject, updateFormObject, saveForm, errors, isLoading, t) => {
  const fields = [
    {
      type: 'text',
      name: 'name',
      label: t('labels.mairie_name'),
      value: mairieFormObject.name,
      key: 'mairieFormObject-name',
      cssClass: 'column is-6'
    },
    {
      type: 'switcher',
      name: 'isActive',
      label: t('labels.is_active'),
      value: mairieFormObject.isActive,
      cssClass: 'column is-6',
      key: 'mairieFormObject-isActive',
      id: 'mairieFormObject-isActive',
    },
    {
      type: 'button',
      buttons: true,
      callback: saveForm,
      cancel: false,
      validateText: t('actions.save'),
      cssClassParent: 'column is-12',
      cssClassValidate: 'button is-blue',
      validateIcon: 'icon-done',
      key: 'mairieFormObject-form',
      isLoading
    },
    {
      type: 'hidden',
      name: 'id',
      value: parseInt(mairieFormObject.id),
      key: 'mairieFormObject-id'
    }
  ]
  return fields.map(function (field) {
    return getField({ ...field, error: errors[field.name] ? errors[field.name].errors : '' }, updateFormObject)
  })
}